import serverCall from "../../serverCall";

const login = (payload) => {
  try {
    const response = serverCall.post(`/auth/login`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

const signup = (email, password) => {
  try {
    const response = serverCall.post(
      `/auth/signUp?email=${email}&password=${password}&signUpType=USER`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const googleLogin = (token) => {
  try {
    const response = serverCall.post(`/auth/google-login`, { token });
    return response;
  } catch (error) {
    throw error;
  }
};

const forgotPassword = (email) => {
  try {
    const response = serverCall.post(`/auth/forgot-password`, { email });
    return response;
  } catch (error) {
    throw error;
  }
};

const verifyResetToken = (token) => {
  try {
    const response = serverCall.get(`/auth/verify-reset-token?token=${token}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const resetPassword = (token, newPassword, confirmPassword) => {
  try {
    const response = serverCall.post(`/auth/reset-password`, { token, newPassword, confirmPassword });
    return response;
  } catch (error) {
    throw error;
  }
};

const logout = () => {
  try {
    return serverCall.post(`/users/logout`);
  } catch (error) {
    throw error;
  }
};

const AuthService = {
  login,
  signup,
  googleLogin,
  forgotPassword,
  verifyResetToken,
  resetPassword,
  logout,
};

export default AuthService;
